export const SOC2_PDF_OBJECT_KEY =
  'public-content/2017-trust-services-criteria-with-revised-points-of-focus-2022.pdf'
export const SOC2_PDF_LINK =
  'https://www.aicpa.org/resources/download/2017-trust-services-criteria-with-revised-points-of-focus-2022'
export const ISO_LINK = 'https://www.iso.org/standard/82875.html'
